import React from 'react'
import { DefaultMarkdown } from '@jelly/templates'

const BdcDefaultMarkdown = (props) => {
	return <DefaultMarkdown {...props} />
}

export default BdcDefaultMarkdown
